import { useEffect, useState } from 'react';
import api from '../api/axios';

const fmt = (d) =>
  d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '';
const fmtTime = (d) =>
  d ? new Date(d).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '';

const negative = ['rejected', 'withdrawn'];

export default function ApplicationTimeline({ applicationId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let alive = true;
    api
      .get(`/my-applications/${applicationId}/timeline`)
      .then((res) => alive && setData(res.data))
      .catch(() => alive && setError(true));
    return () => {
      alive = false;
    };
  }, [applicationId]);

  if (error) return <p className="text-sm text-gray-500">Timeline unavailable right now.</p>;
  if (!data) return <p className="text-sm text-gray-400">Loading timeline...</p>;

  const lastIdx = data.timeline.length - 1;

  return (
    <div className="mt-3">
      <h4 className="text-sm font-semibold text-gray-700 mb-3">Application Timeline</h4>
      <ol className="relative border-l-2 border-gray-200 ml-2">
        {data.timeline.map((t, i) => {
          const isLast = i === lastIdx;
          const bad = negative.includes(t.status);
          const dot = bad ? 'bg-red-500' : isLast ? 'bg-primary-green' : 'bg-gray-400';
          return (
            <li key={`${t.status}-${i}`} className="mb-4 ml-4">
              <span className={`absolute -left-[7px] mt-1 h-3 w-3 rounded-full ${dot}`} />
              <p className={`text-sm ${isLast ? 'font-semibold text-gray-900' : 'text-gray-700'}`}>{t.label}</p>
              <p className="text-xs text-gray-500">{fmt(t.at)}</p>
            </li>
          );
        })}
      </ol>

      {data.interviews?.length > 0 && (
        <div className="mt-2">
          <h4 className="text-sm font-semibold text-gray-700 mb-2">Interviews</h4>
          {data.interviews.map((iv) => (
            <div key={iv.id} className="text-sm border rounded-lg p-2 mb-2 bg-gray-50">
              <p className="font-medium">{fmtTime(iv.scheduled_at)} · {iv.mode || iv.type}</p>
              <p className="text-xs text-gray-500">Status: {iv.status}</p>
              {iv.meeting_link && (
                <a href={iv.meeting_link} target="_blank" rel="noreferrer" className="text-xs text-primary-blue underline">
                  Join link
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
